import React, { forwardRef } from "react";
import AiGeneratedLabel from "./AiGeneratedLabel";
import "./style.scss";
const AiDashboardComponents = forwardRef(({ title, children, titleStyle = {}, containerStyle = {}, isLabelVisible = true }, ref) => {
    return (React.createElement("div", { className: "ai-dashboard-container", style: containerStyle, ref: ref },
        title && (React.createElement("div", { className: "ai-dashboard-title-container" },
            React.createElement("h3", { className: "ai-dashboard-title", style: titleStyle }, title),
            isLabelVisible && React.createElement(AiGeneratedLabel, null))),
        children));
});
export default AiDashboardComponents;
